// 7 Rankings pages
export const RANKINGS = [
  {
    slug: "overall",
    label: "Overall",
    title: "Best VPNs Overall: 2026 Rankings",
    metaTitle: "Best VPN 2026: Overall Rankings — Top 5 Tested & Scored",
    metaDescription:
      "Our definitive overall VPN ranking for 2026, combining speed, streaming, privacy, features, and value across hundreds of hours of testing.",
    metric: "Overall score",
    intro:
      "Our overall ranking combines every test we run — speed, streaming, security, privacy audits, usability, and value. NordVPN's 9.8/10 leads the field by a clear margin.",
    order: ["nordvpn", "surfshark", "purevpn", "veepn", "adguard-vpn"],
    values: {
      nordvpn: "9.8 / 10",
      surfshark: "9.2 / 10",
      purevpn: "8.7 / 10",
      veepn: "8.1 / 10",
      "adguard-vpn": "7.8 / 10",
    },
  },
  {
    slug: "fastest-vpn",
    label: "Fastest VPN",
    title: "Fastest VPN 2026: Speed Test Rankings",
    metaTitle: "Fastest VPN 2026: We Speed-Tested 5 VPNs — Full Rankings",
    metaDescription:
      "Which VPN is fastest in 2026? We measured speed retention across 47 server locations. NordVPN retained 95%+ of base speed — the fastest we recorded.",
    metric: "Avg. speed retained",
    intro:
      "We measured download speed retention across 47 server locations using WireGuard-class protocols on identical hardware and base connections. NordVPN's NordLynx protocol topped every distance bracket.",
    order: ["nordvpn", "surfshark", "purevpn", "veepn", "adguard-vpn"],
    values: {
      nordvpn: "95% of base speed",
      surfshark: "93% of base speed",
      purevpn: "91% of base speed",
      veepn: "85% of base speed",
      "adguard-vpn": "80% of base speed",
    },
  },
  {
    slug: "best-value-vpn",
    label: "Best Value",
    title: "Best Value VPN 2026: Price-to-Performance Rankings",
    metaTitle: "Best Value VPN 2026: Most VPN for Your Money, Ranked",
    metaDescription:
      "Which VPN gives you the most for your money? We ranked 5 VPNs on price-to-performance. Surfshark's $2.29/month with unlimited devices wins on pure value.",
    metric: "Price/mo (2-yr plan)",
    intro:
      "Value isn't just the sticker price — it's what you get for it. Surfshark's unlimited connections at $2.29/month is the strongest pure-value proposition, while NordVPN's $3.09/month buys the best performance in the market.",
    order: ["surfshark", "nordvpn", "purevpn", "veepn", "adguard-vpn"],
    values: {
      surfshark: "$2.29 — unlimited devices",
      nordvpn: "$3.09 — best performance per dollar",
      purevpn: "$1.99 — lowest price",
      veepn: "$2.50 — unlimited devices",
      "adguard-vpn": "$2.49 — includes ad blocking",
    },
  },
  {
    slug: "best-privacy-vpn",
    label: "Best Privacy",
    title: "Best Privacy VPN 2026: Audit-Verified Rankings",
    metaTitle: "Best Privacy VPN 2026: Audited No-Log VPNs Ranked",
    metaDescription:
      "We ranked 5 VPNs by verifiable privacy: independent audits, jurisdiction, and infrastructure. NordVPN's double tier-1 audit record leads.",
    metric: "Audit record",
    intro:
      "We rank privacy on what can be proven, not what's claimed: independent audits, jurisdiction, RAM-only servers, and real-world seizure history. NordVPN's PwC + Deloitte double audit is the strongest record in the industry.",
    order: ["nordvpn", "surfshark", "purevpn", "adguard-vpn", "veepn"],
    values: {
      nordvpn: "PwC (2022) + Deloitte (2023)",
      surfshark: "Deloitte (2023)",
      purevpn: "KPMG (always-on audit)",
      "adguard-vpn": "No VPN audit — strong brand reputation",
      veepn: "No independent audit",
    },
  },
  {
    slug: "best-streaming-vpn",
    label: "Best Streaming",
    title: "Best Streaming VPN 2026: Unblocking Rankings",
    metaTitle: "Best Streaming VPN 2026: Netflix, iPlayer & More — Ranked",
    metaDescription:
      "We tested 5 VPNs against 7 streaming services. NordVPN's 100% unblocking success rate makes it the best streaming VPN of 2026.",
    metric: "Unblocking success rate",
    intro:
      "Seven streaming services, five VPNs, six weeks of testing. NordVPN was the only VPN with a perfect record — every service, every library, every attempt.",
    order: ["nordvpn", "surfshark", "purevpn", "veepn", "adguard-vpn"],
    values: {
      nordvpn: "100% — all 7 services",
      surfshark: "97% — all 7 services",
      purevpn: "85% — major services",
      veepn: "75% — US libraries best",
      "adguard-vpn": "60% — inconsistent",
    },
  },
  {
    slug: "best-security-features",
    label: "Best Security",
    title: "Best VPN Security Features 2026: Rankings",
    metaTitle: "Best VPN Security Features 2026: Full Stack Comparison",
    metaDescription:
      "Double VPN, Tor integration, threat protection, kill switches — we ranked 5 VPNs by security feature depth. NordVPN's stack is the most complete.",
    metric: "Security stack",
    intro:
      "Beyond baseline AES-256 and kill switches, the leaders differentiate on advanced protections. NordVPN's Double VPN, Onion over VPN, and Threat Protection form the deepest stack we've tested.",
    order: ["nordvpn", "surfshark", "adguard-vpn", "purevpn", "veepn"],
    values: {
      nordvpn: "Double VPN, Onion over VPN, Threat Protection",
      surfshark: "MultiHop, CleanWeb, rotating IP",
      "adguard-vpn": "DNS-level blocking, stealth protocol",
      purevpn: "Core features, multi-protocol",
      veepn: "Core features, NetGuard",
    },
  },
  {
    slug: "best-user-experience",
    label: "Best UX",
    title: "Best VPN User Experience 2026: Rankings",
    metaTitle: "Best VPN Apps 2026: User Experience Ranked Across Platforms",
    metaDescription:
      "Which VPN is easiest to use? We ranked 5 VPNs by app polish, onboarding, and cross-platform consistency. NordVPN's one-click apps lead.",
    metric: "App experience",
    intro:
      "We scored onboarding, connect flow, settings clarity, and cross-platform consistency on Windows, macOS, iOS, and Android. NordVPN's map-based one-click apps set the standard; VeePN deserves credit as the friendliest budget option.",
    order: ["nordvpn", "surfshark", "veepn", "adguard-vpn", "purevpn"],
    values: {
      nordvpn: "One-click connect, map UI, all platforms",
      surfshark: "Clean apps, unlimited installs",
      veepn: "Simplest onboarding for beginners",
      "adguard-vpn": "Polished apps, integrated blocking",
      purevpn: "Functional but less refined",
    },
  },
];

export const getRanking = (slug) => RANKINGS.find((r) => r.slug === slug);
